import { Radio } from "antd";
import { clsxMerge } from "../../utils/classNameUtils";
import { radioStyles } from "./helpers";

export const CustomRadio = ({
  value,
  label,
  subText,
  selected,
  setSelected,
  disabled,
}: {
  value: string;
  label: string;
  subText: string;
  selected: string;
  setSelected: (val: string) => void;
  disabled: boolean;
}) => {
  return (
    <div
      className={clsxMerge(
        radioStyles({ variant: selected === value ? "selected" : "default" })
      )}
      onClick={() => !disabled && setSelected(value)}
    >
      <Radio checked={selected === value} onChange={() => setSelected(value)} />
      <div>
        <p className="text-steelBlue text-sm font-medium">{label}</p>
        <p className="text-gray200 text-sm">{subText}</p>
      </div>
    </div>
  );
};
